import { useDebounceCallback } from "@devhop/ui";
import { useEffect, useMemo, useState } from "react";
import { toISOString } from "@/shared/lib/date-time-performance";
import { useEventDateConflictsQuery } from "../api/queries";

type EventDateConflictCheckInput = {
  eventDate: string | null | undefined;
  endDate?: string | null;
  excludeEventId?: string;
  excludeRequestId?: string;
};

export function useEventDateConflictCheck(input: EventDateConflictCheckInput) {
  const [debounced, setDebounced] = useState(input);
  const debounce = useDebounceCallback((next: EventDateConflictCheckInput) => {
    setDebounced(next);
  }, 350);

  useEffect(() => {
    debounce(input);
  }, [debounce, input.eventDate, input.endDate, input.excludeEventId, input.excludeRequestId]);

  const query = useMemo(() => {
    if (!debounced.eventDate?.trim()) return null;
    return {
      eventDate: toISOString(new Date(debounced.eventDate)),
      endDate: debounced.endDate?.trim()
        ? toISOString(new Date(debounced.endDate))
        : undefined,
      excludeEventId: debounced.excludeEventId,
      excludeRequestId: debounced.excludeRequestId,
    };
  }, [debounced]);

  const result = useEventDateConflictsQuery(query);

  return {
    conflicts: result.data?.items ?? [],
    isChecking: result.isFetching && !!query,
  };
}
